import { labelFonti, labelSelected } from "_constants";

export const FooterLeftAddSourceArchive = ({
  sourceIdsList,
}: {
  sourceIdsList: any[];
}) => {
  return (
    <>
      <div className="flex-container gap-3">
        <span className="text-footer-bold">
          {`${sourceIdsList.length} ${labelFonti.toLowerCase()}`}
        </span>
        <span>{labelSelected}</span>
      </div>
    </>
  );
};
